var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconLanguage = function SvgIconLanguage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M12 19.509a7.51 7.51 0 1 0 0-15.018 7.51 7.51 0 0 0 0 15.018m0-1.5h.041q.173-.27.35-.58c.677-1.194 1.333-2.802 1.473-4.688h-3.728c.14 1.886.797 3.494 1.473 4.688q.177.31.35.58zm-1.863-6.768c.144-1.877.797-3.479 1.472-4.669q.178-.312.35-.581h.082q.173.27.35.581c.675 1.19 1.329 2.792 1.472 4.67zm5.23 0c-.13-1.952-.741-3.631-1.409-4.924a6.02 6.02 0 0 1 4.004 4.924zm.001 1.5h2.596a6.02 6.02 0 0 1-4.005 4.941c.669-1.296 1.282-2.98 1.409-4.94m-6.735-1.5H6.038a6.02 6.02 0 0 1 4.004-4.924c-.667 1.293-1.28 2.972-1.409 4.924m-2.597 1.5h2.596c.127 1.96.74 3.646 1.41 4.942a6.02 6.02 0 0 1-4.006-4.942",
    clipRule: "evenodd"
  })));
};
export default SvgIconLanguage;